import { Injectable } from '@angular/core';
import { HeaderStaticTypes, IHeader } from '@effy-tech/acquisition-core/header';
import { Observable } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';
import { GetDataService } from '../../graphql/graphql.service';
import { DeviceManagerService } from '../device-manager/device-manager.service';

@Injectable({
  providedIn: 'root',
})
export class HeaderStaticPagesService {
  constructor(
    private readonly getDataService: GetDataService,
    private readonly deviceManagerService: DeviceManagerService
  ) {}

  public getHeaderStaticPagesData$(headerType: HeaderStaticTypes): Observable<IHeader> {
    return this.getDataService.getHeaderStaticPagesData$(headerType).pipe(
      filter(data => !!data),
      map((data: IHeader) => {
        data.isDesktop$ = this.deviceManagerService.deviceType$().pipe(map(deviceType => deviceType.bigViewPort));
        return data;
      }),
      shareReplay()
    );
  }
}
